<template>
  <div class="notexpired-box">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.list"
        :key="i + '-list'"
        :value="null"
        :border="false"
      >
        <template #value>
          <img class="coupon-action" @click="onDelete(item)" src="@/assets/trade/aiqu_cancel.webp" alt="">
          <img
            class="orderTips"
            src="../../../assets/coupon/ico_dscountorder.png"
            alt=""
            v-if="item.dscountorder == 1"
          />
          <div class="game-div" v-if="item.is_split == 0">
            <div id="recycle-info">
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
              <p>满{{ item.pay_money }}元使用</p>
            </div>

            <div class="coupon-item">
              <p>{{ item.coupon_name }}</p>
              <p>适用于{{ item.gamename }}</p>
              <p>有效期至 {{ item.end_time.slice(0, 16) }}</p>
            </div>
          </div>

          <!-- 可拆分优惠券 -->
          <div class="game-div" v-else-if="item.is_split === 1">
            <div id="recycle-info">
              <p class="split">余额</p>
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
            </div>

            <div class="coupon-item">
              <p>
                <span>{{ item.coupon_name }}</span>
                <span>（可拆分使用）</span>
                <img
                  src="../../../assets/coupon/icon_split_tips.png"
                  alt=""
                  @click="openTips"
                />
              </p>
              <p>适用于{{ item.gamename }}</p>
              <p>有效期至 {{ item.end_time.slice(0, 16) }}</p>
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import {
  reactive,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  onActivated,
  onDeactivated,
  onUnmounted,
} from "vue";
import { Dialog, Toast } from "vant";
import { disablecoupon } from "@/api/coupon";
import { mycoupons } from "@/api/user";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import bus from "@/utils/bus";

export default {
  name: "notexpired",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    // 加载数据
    onBeforeMount(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
        store.dispatch("getInfo");
      }
    });

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = async () => {
      var data = {
        status: 0,
        pagecode: pagecode,
        uid: getQueryString("uid"),
      };
      await mycoupons(data).then((response) => {
        // console.log('返回的数据---------------------', response.data.data)

        if (response.data.code == 1) {
          // console.log('当前页面---------------------', pagecode)
          if (pagecode > response.data.data.total_page) {
            state.finished = true;
            return;
          }
          totalpage = response.data.data.total_page;
          state.list = state.list.concat(response.data.data.lists);
          // 清除id重复的数据
          var obj = {};
          state.list = state.list.reduce(function(item, next) {
            obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
            return item;
          }, []);
          // console.log(state.list);
          pagecode++;
        } else {
          state.finished = true;
        }
      });
      state.loading = false;
    };
    // onLoad()

  

    // 删除优惠券（软删除，可在已删除列表找回）
    const onDelete = (item) => {
      Dialog.confirm({
        title: "提示",
        message: "是否删除当前优惠券（可在已删除列表中找回）",
      })
        .then(() => {
          disablecoupon({ uid: getQueryString("uid"), cid: item.cid }).then((res) => {
            if (res.data.code == 1) {
              state.list = state.list.filter((c) => c.id !== item.id);
              bus.emit("refreshDeleted");
              Toast(res.data.msg || "删除成功");
            } else {
              Toast(res.data.msg || "删除失败");
            }
          });
        })
        .catch(() => {});
    };

    const markRefresh = () => {
      needRefresh = true;
    };
    bus.on("refreshNotExpired", markRefresh);
    onUnmounted(() => {
      bus.off("refreshNotExpired", markRefresh);
    });
    // 被其他 tab 的操作标记为待刷新；真正刷新延迟到本 tab 激活（组件进入 DOM、可见）时执行，
    // 否则 keep-alive 缓存的组件不在 DOM 中，van-list 无法检测滚动、只能加载一页。
    let needRefresh = false;
    onActivated(() => {
      pagecode = 1;
      totalpage = 1;
      state.finished = false;
      if (needRefresh) {
        needRefresh = false;
        state.list = [];
        // 关键：置 loading=true 并主动加载第一页；加载完 loading 由 true→false 的变化
        // 会让 van-list 继续检测、自动翻页，避免停在空列表/只有一页。
        state.loading = true;
        onLoad();
      } else {
        state.loading = false;
      }
    });
    onDeactivated(() => {
      // console.log('离开过期优惠券页面-----------------')
      pagecode = 1;
      totalpage = 1;
      // state.list = [];
      state.loading = false;
      state.finished = false;
    });

    const openTips = () => {
      bus.emit("splitShow");
    };

    return {
      state,
      onLoad,
      openTips,
      onDelete,
    };
  },
};
</script>

<style scoped="scoped" lang="less">
.van-tabs--card {
  background: #fff;
}

@commonColor: #12cec7;

.notexpired-box {
  height: 100vh;
  background-color: #f7f8fa;

  .orderTips {
    width: 64px;
    height: 30px;
    position: absolute;
    left: -6px;
    top: 13px;
  }
  .coupon-action  {
    position: absolute;
    right: 24px;
    top: 36px;
    width: 28px;
    height: 28px;
    padding: 4px;
    opacity: 0.65;
  }

  .van-cell {
    background-color: #f7f8fa;
    padding: 10px 32px;
    :deep(.van-cell__value) {
      overflow: visible;
    }
  }
  .game-div {
    display: flex;
    margin-top: 10px;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    height: 160px;
    width: 686px;
    background: url(../../../assets/coupon/yz_wdyhq_bj1.png) no-repeat center top;
    background-size: 100% 100%;

    #recycle-info {
      width: 176px;
      height: 160px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .split {
        font-size: 24px;
      }

      h3 {
        font-size: 40px;
        color: @commonColor;
        // margin-left: 20px;
        // margin-top: 10px;

        span {
          font-size: 20px;
          color: @commonColor;
        }
      }

      p {
        font-size: 16px;
        color: @commonColor;
      }
    }

    .coupon-item {
      margin-left: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        font-size: 20px;
        color: #8f9197;
        display: flex;
        align-items: center;
        line-height: 1.8;

        &:nth-of-type(1) {
          font-size: 28px;
          color: #000;
          font-weight: 500;

          span {
            font-size: 20px;

            &:nth-of-type(1) {
              font-size: 28px;
              max-width: 252px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              text-overflow: ellipsis;
            }
          }

          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
  ::v-deep .van-list__finished-text {
    background-color: #f7f8fa;
  }
}
</style>
